<template>
    <v-dialog v-model="dialog" :width="width" persistent scrollable >
        <v-card>
            <v-toolbar flat dark color="primary" max-height="64">
                <v-toolbar-title>Nieuwe versie beschikbaar</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pt-4">
                <p>
                    Er is een nieuwe versie van BOSS beschikbaar: <strong>Atlas</strong>.
                </p>
                <p>
                    We raden aan om over te stappen naar de nieuwe versie voor de beste ervaring
                    en de nieuwste functies.
                </p>
                <p>Na <strong>31 sep. 2026</strong> is deze versie niet meer beschikbaar.</p>
            </v-card-text>
            <v-card-actions>
                <v-btn color="secondary" outlined :disabled="cancelDisabled" @click="close">
                    Annuleren
                    <span v-if="cancelDisabled" class="ml-1">({{ countdown }})</span>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="goToAtlas">
                    <v-icon left>mdi-arrow-right</v-icon>
                    Naar nieuwe versie (Atlas)
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        width: {
            type: Number,
            default: 800,
        },
    },
    data() {
        return {
            dialog: false,
            cancelDisabled: true,
            countdown: 10,
            countdownTimer: null,
        }
    },
    mounted() {
        this.open();
    },
    methods: {
        open() {
            this.dialog = true;
            this.cancelDisabled = true;
            this.countdown = 10;
            this.countdownTimer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(this.countdownTimer);
                    this.cancelDisabled = false;
                }
            }, 1000);
        },
        close() {
            if (this.cancelDisabled) {
                return;
            }
            this.dialog = false;
            this.cleanup();
        },
        goToAtlas() {
            this.cleanup();
            window.location.href = '/atlas';
        },
        cleanup() {
            if (this.countdownTimer) {
                clearInterval(this.countdownTimer);
                this.countdownTimer = null;
            }
        },
    },
    beforeDestroy() {
        this.cleanup();
    },
}
</script>
